<template>
    <modal class="HandWorkUpdateModel" :isShow="isShow"  @keyup.esc="hide">
        <div class="header">手工调账</div>
        <div class="modal-body">
            <div class="filter-box">
                <div class="bnt verticalCenter" :class="{selected:!queryType}" @click="nowadays()" >
                    <div class="title">
                        <span>今天<br/>({{userInfo.Rpt_Date}})</span>
                    </div>
                </div>
                <div class="bnt verticalCenter" :class="{selected:queryType}" @click="queryType=true">
                    <div class="title">
                        <span>按日期范围</span>
                    </div>
                </div>
                <div class="inline-block">
                    <el-date-picker class="from-date"
                        v-model="businessHours"
                        type="daterange"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="defaultTime"
                        @change="change"
                        :disabled='!queryType'
                    > </el-date-picker>
                </div>
                <div class="query-bnt" @click="loadData()">查询</div>
                <div class="flex1"></div>
                <div class="bnt verticalCenter bnt-add" @click="addIsShow=true">
                    <div class="title"><i class="iconfont icon-jia"></i>&nbsp;新增调账</div>
                </div>
            </div>
            <div class="content-box">
                <div class="table-box grey-table">
                    <el-table class="el-table--scrollable-y"  :data="tableListPage" border height="430"
                        v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}">
                        <el-table-column label="序号" width="50" type="index">
                            <template #default="scope">{{scope.$index+1+(pageSize*(currentPage-1))}}</template>
                        </el-table-column>
                        <el-table-column prop="Rpt_Date" label="营业日期" width="80" :formatter="shortDateFormat"></el-table-column>
                        <el-table-column prop="Eat_CheckNo" label="结账单号" min-width="150"></el-table-column>
                        <el-table-column prop="Eat_CheckMoney" align="right" label="调整金额" min-width="80" data-format="number"></el-table-column>
                        <el-table-column prop="Pay_Name" label="付款方式" min-width="120"></el-table-column>
                        <el-table-column prop="Eat_CZY" label="操作人" min-width="80"></el-table-column>
                        <el-table-column prop="Eat_CheckTime" label="操作时间" width="130" :formatter="dateFormat"></el-table-column>
                    </el-table>
                </div>
                <table-page-btn class="fy" :data="tableList" 
                    :default-index="currentPage" 
                    @current-change="(index)=>currentPage=index"
                    @page-change="(list)=>tableListPage=list" 
                    :page-size="pageSize"/>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">返回</button>
        </div>
        
        <modal-load :isShow="addIsShow" isUnload>
            <add-hand-work-model :isShow="addIsShow" @close="addIsShow=false" @confirm="addConfirm"/>
        </modal-load>
    </modal>
</template>

<script>
import addHandWorkModel from './addHandWorkModel/addHandWorkModel.vue'
// 手工调账功能
export default {
    name:'HandWorkUpdateModel',
    components:{
        addHandWorkModel
    },
    emits:["close"],
    props:{
        isShow:Boolean,
    },
    data(){
        return{
            //新增调账
            addIsShow:false,
            userInfo:{},
            queryType:false,
            /**默认日期范围 */
            defaultTime:[new Date(),new Date()],
            /**选中日期范围 */
            businessHours:[new Date(),new Date()],
            currentPage:1,
            pageIndex:1,
            pageSize:10,
            tableList:[],
            tableListPage:[],
           
        }
    },
    mounted(){
        
        this.$nextTick(()=>{
            this.userInfo = this.$auth.getUserInfo();
            this.businessHours=[this.userInfo.Rpt_Date,this.userInfo.Rpt_Date];
            this.loadData();
        });
    },
    watch:{
        isShow(newValue){
            if(newValue){
                this.loadData();
            }
        }
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        //加载数据
        loadData(){
            let time = JSON.parse(JSON.stringify(this.businessHours));
            const loading = this.$loading({
                text: "获取手工调账数据中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            let userInfo=this.$auth.getUserInfo(); //获取用户id
            this.$httpAES.post("Bestech.CloudPos.GetManualAccountAdjustments", {
                User_ID:userInfo.User_ID,
                DateRange_YN:this.queryType,//是否日期范围查询  true: 日期范围    false：当前营业数据
                Begin_Date:new Date(time[0]).Format("yyyy-MM-dd"),//开始日期
                End_Date:new Date(time[1]).Format("yyyy-MM-dd"), //结束日期
            }).then((d)=>{
                console.log(d)
                loading.close();
                if(d.ResponseHeader.ResultCode!=0){
                    this.pageIndex=1;
                    this.tableList=[];
                    this.$message.error(d.ResponseHeader.ResultDesc);
                    return;
                }else{
                    this.tableList=d.ResponseBody||[];
                    this.pageIndex=1;
                }
            }).catch((e)=>{
                loading.close();
                this.$alert("手工调账加载失败"+e.message, "提示", {confirmButtonText: "确定"});
            });
        },
         /*单价格式 截取两位小数 */
        priceFormat(row, column, cellValue){
            if(isNaN(cellValue)){
                return ""
            }else{
                return parseFloat(parseFloat(cellValue).toFixed(2));
            }
        },
        dateFormat(row, column, cellValue){
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        /*时间格式 */
        shortDateFormat(row, column, cellValue){
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd');
        },
        /**今日 */
        nowadays(){
            this.queryType=false
            let Rpt_Date=new Date(this.userInfo.Rpt_Date);
            Rpt_Date.setDate(Rpt_Date.getDate()-1);
            this.businessHours=[Rpt_Date.Format("yyyy-MM-dd"),Rpt_Date.Format("yyyy-MM-dd")];
        },
        change(){
            if(!this.queryType){
                this.queryType=true
            }
        },
        addConfirm(){
            this.addIsShow=false;
            if(!this.queryType){
                this.loadData();
            }
        }
    }
}
</script>

<style lang="scss">
@import './HandWorkUpdateModel.scss'
</style>